import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import getWelcomeDevexMetaData from '../services/developerExchangeWelcomeMessageService';
import {
  getPremiumUrl,
  getVerifyEmailUrl,
  getTermUrl,
  getTermOfServiceUrl
} from '../constants/developerExchangeWelcomeMessageConstants';

function DevExWelcomeMessage({ translate }) {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    getWelcomeDevexMetaData().then(result => {
      const { redirectUrl } = result.data;
      if (result.data) {
        if (redirectUrl) {
          window.location.href = redirectUrl;
        } else {
          setLoading(false);
        }
        setInfo(result.data);
      }
    });
  }, []);

  const descriptionWelcomeDevExParagraphTwo = () => {
    return translate('Description.WelcomeDevExParagraphTwo', {
      minCashoutValue: info?.minRobuxToCashOut
    });
  };

  const getMinRobuxTermText = () => {
    return translate('Description.WelcomeDevExTermMinCashoutValue', {
      minCashoutValue: info?.minRobuxToCashOut
    });
  };

  const getEmailNotVerifiedText = () => {
    return translate('Description.WelcomeDevExTermNoVerifiedEmail', {
      startVerifyEmailLink: `<a target="_blank" href="${getVerifyEmailUrl}" className="text-link">`,
      endVerifyEmailLink: '</span>'
    });
  };

  const getGoodStandingTermText = () => {
    return translate('Description.WelcomeDevExTermGoodMember', {
      termLinkStart: `<a target="_blank" href="${getTermUrl}" className="text-link">`,
      termLinkEnd: '</span>'
    });
  };
  const devExTerms = () => {
    const terms = [];
    terms.push(<li>{getMinRobuxTermText()}</li>);
    if (info?.emailIsVerified) {
      terms.push(<li>{translate('Description.WelcomeDevExTermVerifiedEmail')}</li>);
    } else {
      terms.push(<li dangerouslySetInnerHTML={{ __html: getEmailNotVerifiedText() }} />);
    }
    terms.push(<li>{translate('Description.WelcomeDevExTermValidAccount')}</li>);
    terms.push(<li>{translate('Description.WelcomeDevExTermValidAge')}</li>);
    terms.push(<li dangerouslySetInnerHTML={{ __html: getGoodStandingTermText() }} />);
    return terms;
  };

  const getCanProceedCashoutText = () => {
    if (info?.canProceedToCashout) {
      return <p>{translate('Description.WelcomeDevExCanProceedCashout')}</p>;
    }
    return <p>{translate('Description.WelcomeDevExCanNotProceedCashout')}</p>;
  };

  const getTexEducationText = <p>{translate('Description.WelcomeDevExWeRecommend')}</p>;

  const getMoreInfoText = () => {
    return translate('Description.WelcomeDevExMoreDevExInfo', {
      helpLinkStart: `<a target="_blank" href="${info?.robloxDevExHelpFullUrl}" className="text-link">`,
      helpLinkEnd: '</span>'
    });
  };

  const getDevExTosText = () => {
    return translate('Description.WelcomeDevExTermsLink', {
      termLinkStart: `<a target="_blank" href="${getTermOfServiceUrl}" className="text-link">`,
      termLinkEnd: '</span>'
    });
  };

  const indent = ' ';

  const messageBody = !loading && (
    <div>
      <h2>{translate('Heading.WelcomeDevEx')}</h2>
      <p className='indet'>{translate('Description.WelcomeDevExParagraphOne')}</p>
      <p>{descriptionWelcomeDevExParagraphTwo()}</p>
      <p> {translate('Description.WelcomeDevExParagraphThree')} </p>
      <ul>{devExTerms()}</ul>
      {getCanProceedCashoutText()}
      {getTexEducationText}
      <p>
        {translate('Description.WelcomeDevExIfRequestApproved')} {indent}
        <strong>{translate('Description.WelcomeDevExMakeSureCorrectInfo')}</strong>
        {indent}
        {translate('Description.WelcomeDevExInfoImpact')}
      </p>
      <p>
        <div dangerouslySetInnerHTML={{ __html: getMoreInfoText() }} />
        <div dangerouslySetInnerHTML={{ __html: getDevExTosText() }} />
      </p>
    </div>
  );

  return <div>{messageBody}</div>;
}

DevExWelcomeMessage.propTypes = {
  translate: PropTypes.func.isRequired
};

export default DevExWelcomeMessage;
